import React, { useState, useEffect } from "react";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import "./Promocode.css";

const PromoCode = ({ totalAmount, onApply, onRemove, cartItems, addressId, appliedPromo }) => {
  const [promoCodes, setPromoCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inputCode, setInputCode] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState(appliedPromo || null);

  useEffect(() => {
    fetchPromocodes();
  }, [totalAmount]);

  useEffect(() => {
    if (appliedPromo) {
      setSelectedPromo(appliedPromo);
    }
  }, [appliedPromo]);

  console.log(cartItems, "cart items before promo api");
  console.log(addressId, "cart items before promo api");

  // ✅ FETCH PROMOS
  const fetchPromocodes = async () => {
    setLoading(true);
    try {
      const payload = {
        cartItems,
        addressId,

        companyCode:
          initialAuthState.companyCode,

        unitCode:
          initialAuthState.unitCode,
      };

      const response = await ApiService.post(
        "/promocode/getEligiblePromos",
        payload
      );

      console.log(response.data, "promodoceds")

      if (response?.status) {
        const today = new Date();

        setPromoCodes(response.data || []);

        // const eligible = response.data
        //   .filter((promo) => {
        //     if (promo.promoStatus !== "Active") return false;

        //     console.log("PROMO:", promo.promocode);
        //     console.log("TOTAL:", totalAmount);
        //     console.log("MIN:", promo.minOrderAmount);
        //     console.log("START:", promo.startDate);
        //     console.log("END:", promo.endDate);

        //     const start = new Date(promo.startDate);
        //     const end = new Date(promo.endDate);

        //     if (today < start || today > end) return false;

        //     return (
        //       parseFloat(totalAmount || 0) >=
        //       parseFloat(promo.minOrderAmount || 0)
        //     );
        //   })
        // .map((promo) => {
        //   const usedByUser = promo.promoUsers?.[22] ? true : false;
        //   return { ...promo, usedByUser };
        // });

        // console.log(eligible, "promos")

        // setPromoCodes(eligible);
      }
    } catch (error) {
      console.error("Error fetching promocodes:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ APPLY FROM INPUT
  const handleApplyCode = () => {
    if (!inputCode.trim()) {
      setMessage("Please enter a promo code!");
      return;
    }

    const promo = promoCodes.find(
      (p) =>
        p.promocode.toLowerCase() === inputCode.trim().toLowerCase()
    );

    if (!promo) {
      setMessage("Invalid or ineligible promo code!");
      return;
    }

    if (!promo.isEligible) {
      setMessage(promo.reason || "Promo not eligible");
      return;
    }

    applyPromo(promo);
  };

  // ✅ APPLY LOGIC
  const applyPromo = (promo) => {
    const subtotal = Number(totalAmount) || 0;
    let discount = 0;

    if (promo.discountType.toLowerCase() === "amount") {
      discount = parseFloat(promo.discount);
    } else {
      discount =
        (subtotal * parseFloat(promo.discount)) / 100;
    }

    if (
      promo.maxDiscountAmount &&
      discount > parseFloat(promo.maxDiscountAmount)
    ) {
      discount = parseFloat(promo.maxDiscountAmount);
    }

    setSelectedPromo(promo);
    onApply(discount, promo);

    setMessage(`Promo "${promo.promocode}" applied successfully!`);
    setInputCode("");
    setShowModal(false);
  };

  // ✅ REMOVE
  const removePromo = () => {
    setSelectedPromo(null);
    setInputCode("");
    setMessage("");
    onRemove();
  };

  const handleShowPromoCodes = () => {
    fetchPromocodes();
    setShowModal(true);
  };

  return (
    <>
      {/* HEADER */}
      <div className="PromoCode-header">
        <h3>Promo Code</h3>
        <span className="PromoCode-subtext">
          Apply a coupon to save on your order
        </span>
      </div>

      {/* APPLIED */}
      {selectedPromo ? (
        <div className="PromoCode-applied-card">
          <div className="PromoCode-applied-left">
            <span className="PromoCode-applied-icon">🏷</span>
            <div>
              <div className="PromoCode-applied-code">
                {selectedPromo.promocode}
              </div>
              <div className="PromoCode-applied-discount">
                {selectedPromo.discountType.toLowerCase() === "amount"
                  ? `₹${selectedPromo.discount} OFF`
                  : `${selectedPromo.discount}% OFF`}
              </div>
            </div>
          </div>

          <button
            className="PromoCode-removeBtn"
            onClick={removePromo}
          >
            Remove
          </button>
        </div>
      ) : (
        <>
          {/* INPUT */}
          <div className="PromoCode-inputWrapper">
            <input
              type="text"
              value={inputCode}
              placeholder="Enter promo code"
              onChange={(e) => setInputCode(e.target.value)}
              className="PromoCode-input"
            />

            <button
              onClick={handleApplyCode}
              className="PromoCode-applyBtn"
              disabled={!inputCode.trim()}
            >
              Apply
            </button>
          </div>

          <button
            onClick={handleShowPromoCodes}
            className="PromoCode-viewBtn"
          >
            View Available Offers
          </button>
        </>
      )}

      {/* MESSAGE */}
      {message && (
        <p
          className={`PromoCode-message ${message.includes("successfully") ? "success" : "error"
            }`}
        >
          {message}
        </p>
      )}

      {/* MODAL */}
      {showModal && (
        <div className="PromoCode-modal">
          <div className="PromoCode-modalContent">
            <h4>Available Promo Codes</h4>

            <span
              className="PromoCode-closeBtn"
              onClick={() => setShowModal(false)}
            >
              &times;
            </span>

            {loading ? (
              <p>Loading promo codes...</p>
            ) : (
              <div className="PromoCode-cards">
                {promoCodes.length > 0 ? (
                  promoCodes.map((promo) => (
                    <div
                      key={promo.id}
                      // className={`PromoCode-voucher ${selectedPromo?.id === promo.id ? "selected" : ""
                      //   } 
                      //   `}
                      className={`PromoCode-voucher
                        ${selectedPromo?.id === promo.id ? "selected" : ""}
                        ${!promo.isEligible ? "disabled" : ""}
                      `}

                      style={{
                        cursor: promo.isEligible ? "pointer" : "not-allowed",
                        opacity: promo.isEligible ? 1 : 0.6,
                      }}
                      onClick={() => {
                        // if (!promo.usedByUser) {
                        if (!promo.isEligible) return;
                        applyPromo(promo);
                        // }
                      }}
                    // style={{
                    //   cursor: promo.usedByUser
                    //     ? "not-allowed"
                    //     : "pointer",
                    //   opacity: promo.usedByUser ? 0.5 : 1,
                    //   pointerEvents: promo.usedByUser
                    //     ? "none"
                    //     : "auto",
                    // }}
                    >
                      <div className="voucher-left">
                        <h4>
                          {promo.discountType.toLowerCase() === "amount"
                            ? `₹${promo.discount}`
                            : `${promo.discount}%`}
                        </h4>
                        <span>Discount</span>
                      </div>


                      <div className="voucher-right">
                        <small>Voucher Code</small>
                        <p>{promo.promocode}</p>

                        <small>
                          Min. order: ₹{promo.minOrderAmount}
                        </small>

                        <br />

                        {/* <small>
                          {promo.usedByUser
                            ? "Already Used"
                            : "Click to apply"}
                        </small> */}

                        <small
                          style={{
                            color: promo.isEligible ? "green" : "red",
                            fontWeight: 500,
                          }}
                        >
                          {promo.isEligible
                            ? "Click to apply"
                            : promo.reason || "Not eligible"}
                        </small>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>
                    No eligible promo codes available for your order.
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PromoCode;